import { fetchUtils } from 'ra-core'

const getAccessToken = () => {
  const token = localStorage.getItem('access_token')
  return Promise.resolve(token)
}

const externalHttpClient = (url, options: any = {}) => {
  // Skip API calls to /users/me and /2fa/clear-verification during 2FA verification
  const currentPath = window.location.pathname
  if (
    (currentPath === '/verify-2fa' || currentPath === '/setup-2fa') &&
    (url.includes('/users/me') || url.includes('/2fa/clear-verification'))
  ) {
    // Return a rejected promise with a custom error
    return Promise.reject(
      new Error('Skipping API call during 2FA verification')
    )
  }

  const noptions = options

  if (!noptions.headers) {
    noptions.headers = new Headers({ Accept: 'application/json' })
  }
  return getAccessToken().then((token) => {
    if (token) {
      noptions.headers.set('Authorization', `Bearer ${token}`)
    }
    return fetchUtils.fetchJson(url, noptions)
  })
}

export default externalHttpClient
